import { render, staticRenderFns } from "./MerchantPerformance.vue?vue&type=template&id=394d346b"
import script from "./MerchantPerformance.vue?vue&type=script&lang=js"
export * from "./MerchantPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports